import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import { CustomDrawer } from 'components';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

interface Props {
    open: boolean;
    closeModal: () => void;
    selectedData: any;
    headerText: string;
}

const View = (props: Props) => {
    const { closeModal, open, selectedData, headerText } = props;

    const { formatMessage } = useIntl();

    return (
        <CustomDrawer
            formMode={'view'}
            open={open}
            onCancel={closeModal}
            title={headerText}
            size='md'
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {selectedData?.survey_answers?.map((sur: any, ind: number) =>
                        <Accordion key={ind} defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="h6" fontWeight="bold">{sur.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {sur.answer}
                            </AccordionDetails>
                        </Accordion>
                    )}
                </Grid>
            </Grid>
        </CustomDrawer>
    )
}

export default View;
